/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import analytics from "../analytics/analytics";
import requester from "modules/requester";
import template from "templates/modules/saved_search_button";
import logging from "utils/logging";
import userProfiler from "modules/userprofiler";
import url from "utils/url";
import { gettext } from "modules/django-i18n";

/**
 * This module 'saved-search-button' saves a search for user
 * overlay when clicking "save search" button if you are a logged in
 *
 * @constructor
 * @alias module:components/saved-search-button
 * @extends module:baustein
 */
export default baustein.register("saved-search-button", {
    template,

    defaultOptions: {
        searchQuery: null,
        searchGender: null,
        isSaved: false
    },

    setupEvents(add) {
        add("click", this.toggleSavedSearch);
    },

    onInsert() {
        this.el.disabled = true;

        if (!userProfiler.isLoggedIn()) {
            return;
        }

        const query = url.toURLSearchParams({
            search_query: this.options.searchQuery,
            search_gender: this.options.searchGender
        });

        requester(`/services/saved-search/?${query}`)
            .then(requester.toJSON)
            .then(data => {
                if (data.is_saved) {
                    this._render(true);
                } else if (data.is_saved === false) {
                    this._render(false);
                } else {
                    logging.log("Unexpected error occurred when checking if a search is saved");
                }
                this.el.disabled = false;
            })
            .catch(e => {
                if (e.status !== 404) {
                    logging.error("Could not fetch a status of a saved search", e);
                }
                this.el.disabled = false;
            });
    },

    toggleSavedSearch(event) {
        event.preventDefault();

        if (this.el.disabled) {
            return;
        }

        this.el.disabled = true;

        analytics.event("saved search", "clicked", this.options.searchQuery);

        return requester("/services/saved-search/", {
            method: "PUT",
            body: {
                search_query: this.options.searchQuery,
                search_gender: this.options.searchGender
            }
        })
            .then(requester.toJSON)
            .then(data => {
                if (data.is_saved) {
                    analytics.event("search", "saved", this.options.searchQuery, true);
                    this._render(true);
                } else if (data.is_saved === false) {
                    analytics.event("search", "unsaved", this.options.searchQuery, true);
                    this._render(false);
                } else {
                    logging.log("Unexpected error occurred when saving a search");
                }
                this.el.disabled = false;
            })
            .catch(e => {
                analytics.event("saved search error", "encountered", e, true);
                logging.error("Could not save/un-save search", e);
                this.el.disabled = false;
            });
    },

    _render(isSaved) {
        // 'Follow search"
        let searchCopy = gettext("saved_search_button.initial_text");
        if (isSaved) {
            // 'Followed'
            searchCopy = gettext("saved_search_button.saved_text");
        }
        this.setRenderContext({
            search_summary_bar: {
                search_query: this.options.searchQuery,
                search_gender: this.options.searchGender,
                search_copy: searchCopy,
                is_saved: isSaved
            }
        });
    }
});

